import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import HiredLogo from "@/components/brand/HiredLogo";
import { Mail, RotateCw, ArrowRight } from "lucide-react";

export default function CheckEmail() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [employee, setEmployee] = useState("");
  const [devLink, setDevLink] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setEmail(sessionStorage.getItem("hired_pending_email") || "");
    setEmployee(sessionStorage.getItem("hired_pending_employee") || "");
    setDevLink(sessionStorage.getItem("hired_dev_link") || null);
  }, []);

  const resend = async () => {
    if (!email || !employee) { nav("/signup"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/resend-magic-link", {
        email, employee_slug: employee, origin_url: window.location.origin,
      });
      if (data?.dev_link) {
        sessionStorage.setItem("hired_dev_link", data.dev_link);
        setDevLink(data.dev_link);
      }
      toast.success("New link sent.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not resend");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-obsidian text-ivory flex flex-col">
      <header className="border-b border-line px-6 md:px-10 py-5 flex items-center justify-between">
        <Link to="/"><HiredLogo size={22} /></Link>
        <Link to="/signup" className="text-steel text-sm hover:text-ivory">← Back to signup</Link>
      </header>
      <div className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="max-w-lg text-center">
          <div className="inline-flex items-center justify-center w-14 h-14 border border-gold text-gold mb-8"><Mail size={22} /></div>
          <h1 className="brand-headline text-5xl md:text-6xl">Check your <span className="text-purple italic">email.</span></h1>
          <p className="text-steel text-lg mt-6">
            We sent a secure login link to <span className="text-ivory font-semibold" data-testid="check-email-target">{email || "your email"}</span>.
            Click it to activate your trial.
          </p>
          <button data-testid="resend-magic-link" onClick={resend} disabled={busy}
                  className="mt-10 inline-flex items-center gap-2 text-gold hover:text-white transition-colors">
            <RotateCw size={14} /> {busy ? "Resending…" : "Didn't get it? Resend link"}
          </button>

          {devLink && (
            <div className="mt-14 border border-gold/40 p-6 text-left bg-graphite/40">
              <div className="brand-eyebrow mb-2">DEV MODE · EMAIL NOT SENT</div>
              <p className="text-steel text-xs mb-3">
                Email service isn&apos;t configured in this environment. Use this direct link to continue your trial:
              </p>
              <a href={devLink} data-testid="dev-magic-link" className="text-gold hover:underline text-sm break-all inline-flex items-start gap-2">
                <ArrowRight size={14} className="shrink-0 mt-0.5" /> Activate trial now
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
